<template>
  <article class="voice-view__info iv-p-t-24 iv-p-b-40">
    <div class="iv-main-width">
      <VoicePanel title="心声建议"></VoicePanel>
      <FormLayout 
        :model="personAdviceModel" 
        :list="personAdviceFormOptions">
      </FormLayout>
      <LayoutTitle title="附件信息">
        <FormLayout
          ref="attachmentInfo" 
          :model="attachmentModel"
          :list="attachmentOptions">
        </FormLayout>
      </LayoutTitle>
      <LayoutTitle title="附件信息">
        <FormLayout
          ref="attachmentInfo" 
          :model="theSecondAttachmentModel"
          :list="theSecondAttachmentOptions">
        </FormLayout>
      </LayoutTitle>
      <FooterOperator>
        <div class="iv-text-center">
          <Button 
            type="back" 
            @click="handleClickBack">
            返回
          </Button>
        </div>
      </FooterOperator>
    </div>
  </article>
</template>

<script>
import VoicePanel from '../components/panel.vue'
import formOptions, { attachmentOptions, theSecondAttachmentOptions } from './formOptions'
import FormLayout from '@/components/layout/form'
import LayoutTitle from '@/components/layout/layout-title'
import FooterOperator from '@/components/footer-operator'

export default {
  name: 'VoiceAdviceViewInfo',
  components: { 
    VoicePanel, 
    FormLayout, 
    LayoutTitle, 
    FooterOperator 
  },
  data () {
    return {
      voiceAdviceId: this.$route.query.voiceAdviceId,
      personAdviceFormOptions: [],
      personAdviceModel: {},
      attachmentOptions: [],
      attachmentModel: {},
      theSecondAttachmentOptions: [],
      theSecondAttachmentModel: {}
    }
  },
  created () {
    this.personAdviceFormOptions = formOptions.call(this)
    this.attachmentOptions = attachmentOptions.call(this)
    this.theSecondAttachmentOptions = theSecondAttachmentOptions.call(this)
  },
  methods: {
    handleClickBack () {
      this.$router.push({ 
        name: 'voiceAdviceList',
        query: {
          currentPage: this.$route.query.currentPage || 1,
          voiceCurrentPage: this.$route.query.voiceCurrentPage || 1,
          tabName: this.$route.query.tabName || ''
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.voice-view__info {
  min-height: 100%;
  background-color: #fff;
}
</style>